<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
    <div class="no-field-space">
        <form [formGroup]="form">
            <sc-flex >
                <sc-string-field formControlName="query"
                        [label]="'query' | translate: ['tmc-yard.widgets.sac-client.moving-order-dialog.query', translationService.language]" [grow]="true">
                    </sc-string-field>
                <sc-content-spacer></sc-content-spacer>
                <button mat-stroked-button (click)="refresh()"><sc-icon iconClass="fa-arrows-rotate"></sc-icon></button>
            </sc-flex>
        </form>
    </div>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <sc-flex-fitting-content [vertical]="true">
        <sc-scroll-pane>
            <table mat-table class="mat-table-selection" [dataSource]="dataSource" matSort
                matSortActive="{{sortColumn}}" (matSortChange)="sortChanged($event)" [matSortDirection]="sortDirection">

                <ng-container matColumnDef="noRecord">
                    <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                        {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="carrier">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{'carrier'| translate:['tmc-yard.entity.vehicle.carrier', translationService.language]}}</th>
                    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
                        *matCellDef="let vehicle"> {{vehicle.carrier}} </td>
                </ng-container>

                <ng-container matColumnDef="identifier">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{'numberplate'| translate:['tmc-yard.entity.vehicle.numberplate',
                        translationService.language]}}
                    </th>
                    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
                        *matCellDef="let vehicle"> {{vehicle.identifier}} </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{'name'| translate:['tmc-yard.entity.vehicle.name', translationService.language]}}</th>
                    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
                        *matCellDef="let vehicle"> {{vehicle.name}} </td>
                </ng-container>

                <ng-container matColumnDef="currentStation">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{'currentStation'| translate:['tmc-yard.entity.vehicle.current-station',
                        translationService.language]}}
                    </th>
                    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
                        *matCellDef="let vehicle"> {{vehicle.currentStation}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

                <tr mat-row *matRowDef="let vehicle; columns: columnsToDisplay" [attr.data-vehicle-id]="vehicle.id"
                [ngClass]="{'selected': selectedListEntry == vehicle}" (click)="toggleSelection(vehicle)"></tr>

                <tr [class.hide]="dataSource.data.length > 0" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
            </table>
        </sc-scroll-pane>
    </sc-flex-fitting-content>
</sc-flex>
